import { diffChars } from 'diff';
import { SentenceSplitterSyntax, split } from 'sentence-splitter';

export function splitIntoSentences(
  text: string,
): { sentence: string; offset: number }[] {
  const sentences = split(text).filter(
    (s) => s.type === SentenceSplitterSyntax.Sentence,
  );
  return sentences.map((s) => ({
    sentence: s.raw,
    offset: s.range[0],
  }));
}

export function getTextDiff(
  oldText: string,
  newText: string,
): {
  changedOffset: number;
  originalLength: number;
  newLength: number;
} {
  const diff = diffChars(oldText, newText);
  let changedOffset = 0;
  let originalLength = 0;
  let newLength = 0;
  let index = 0;
  let foundDifference = false;

  for (const part of diff) {
    if (part.added || part.removed) {
      if (!foundDifference) {
        changedOffset = index;
        foundDifference = true;
      }

      if (part.added) {
        newLength += part.count || 0;
      } else if (part.removed) {
        originalLength += part.count || 0;
      }
    } else {
      if (!foundDifference) {
        index += part.count || 0;
      }
    }
  }

  return {
    changedOffset,
    originalLength,
    newLength,
  };
}
